import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ThemeProvider } from '@mui/material';
import { BrowserRouter } from 'react-router-dom';

import theme from "./theme";

const root = ReactDOM.createRoot(document.getElementById('root'));

const app = (
  <ThemeProvider theme={theme}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </ThemeProvider>
);

if (process.env.NODE_ENV === 'development') {
  root.render(
    <React.StrictMode>
      {app}
    </React.StrictMode>
  );
} else {
  root.render(app);
}

reportWebVitals();
